export default "__VITE_ASSET__gVfWFE0S__"